/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientExternalReceiptInformationTypename = "PatientExternalReceiptInformation" as const;

/**
 *
 * @export
 * @interface PatientExternalReceiptInformation
 */
export interface PatientExternalReceiptInformation {
  /**
   *
   * @type {string}
   * @memberof PatientExternalReceiptInformation
   */
  dateOfBirth: string;
  /**
   *
   * @type {string}
   * @memberof PatientExternalReceiptInformation
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof PatientExternalReceiptInformation
   */
  gender: PatientExternalReceiptInformationGenderEnum;
  /**
   *
   * @type {string}
   * @memberof PatientExternalReceiptInformation
   */
  kanaFirstName?: string;
  /**
   *
   * @type {string}
   * @memberof PatientExternalReceiptInformation
   */
  kanaLastName: string;
  /**
   *
   * @type {string}
   * @memberof PatientExternalReceiptInformation
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof PatientExternalReceiptInformation
   */
  receiptCode: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientExternalReceiptInformation
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientExternalReceiptInformationGenderEnum {
  Male = "male",
  Female = "female",
}

export function PatientExternalReceiptInformationFromJSON(json: any): PatientExternalReceiptInformation {
  return PatientExternalReceiptInformationFromJSONTyped(json, false);
}

export function PatientExternalReceiptInformationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientExternalReceiptInformation {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientExternalReceiptInformationTypename,

    dateOfBirth: json["date_of_birth"],
    firstName: json["first_name"],
    gender: json["gender"],
    kanaFirstName: !exists(json, "kana_first_name") ? undefined : json["kana_first_name"],
    kanaLastName: json["kana_last_name"],
    lastName: json["last_name"],
    receiptCode: json["receipt_code"],
  };
}

export function PatientExternalReceiptInformationToJSON(object?: PatientExternalReceiptInformation | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date_of_birth: value.dateOfBirth,
    first_name: value.firstName,
    gender: value.gender,
    kana_first_name: value.kanaFirstName,
    kana_last_name: value.kanaLastName,
    last_name: value.lastName,
    receipt_code: value.receiptCode,
  };
}
